import { createAction , props } from '@ngrx/store';

export const fetchLanguages = createAction(
  "[Language] Fetch Languages",
  props<{ filterOptions }>()
);

export const fetchLanguagesSuccess = createAction(
  "[Language] Fetch Languages Success",
  props<{ languages }>()
);

export const fetchLanguagesFailure = createAction(
  "[Language] Fetch Languages Faild",
  props<{ error }>()
);
